import { Color, DefaultValue } from '@billy/design-system'
import styled from '@emotion/styled'

export const SidebarWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--lumen-spacing-12);
  min-height: 0;
`

export const SidebarContainer = styled.ul`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  margin: 0;
  padding: 0;
  border: 1px solid ${Color.Grey200};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
`

export const SidebarListItem = styled.li`
  display: block;
  border-bottom: 1px solid ${Color.Grey100};

  &:last-child {
    border-bottom: none;
  }
`

export const EmptyState = styled.li`
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: column;
  gap: var(--lumen-spacing-8);
  justify-content: center;
  padding: var(--lumen-padding-16);
  text-align: center;
`
